import React from 'react';
import DataRoom from '../components';
import DocumentsProvider from '../provider/DocumentsProvider';

export default function DataRoomContainer() {
  return (
    <DocumentsProvider hash>
      <DataRoom />
    </DocumentsProvider>
  );
}
